import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from './components/Navbar';

import './css/App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from "./components/Layout";
import Head from "./components/Head";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Catogery from "./pages/Catogery";

function App() {
  return (
    <BrowserRouter>
      <Head />
      <Navbar />
      <Routes>
        <Route path="*" element={<Layout />} />

        <Route path="/About" element={<About />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Contact" element={<Contact />} />
<Route path="/Catogery" element={<Catogery />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;


